import { render, staticRenderFns } from "./BindUser.vue?vue&type=template&id=d23a3416&scoped=true&"
import script from "./BindUser.vue?vue&type=script&lang=js&"
export * from "./BindUser.vue?vue&type=script&lang=js&"
import style0 from "./BindUser.vue?vue&type=style&index=0&id=d23a3416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a3416",
  null
  
)

export default component.exports